export const facialRecognition = {
  'All right!': '¡Todo bien!',
  'We’ve confirmed your identity! You can keep enjoying a hair-free life with us!':
    '¡Confirmamos tu identidad! ¡Ya podés seguir disfrutando de una vida sin vellos con nosotros!',
  'Hi, {{name}}!': '¡Hola, {{name}}!',
  'We identified {{count}} absence(s)/cancellation(s) with less than 24h notice in your last {{analyzed}} appointments (limit: {{limit}}).':
    'Identificamos {{count}} inasistencia(s)/cancelación(es) con menos de 24h en tus últimos {{analyzed}} turnos (límite: {{limit}}).',
  'Because of that, this unit is temporarily unable to schedule new appointments for you.':
    'Por eso, esta unidad está temporalmente impedida de agendar nuevos turnos para ti.',
  'To keep scheduling with us, we need to confirm your identity through facial recognition. It only takes a few seconds.':
    'Para seguir agendando con nosotros, necesitamos confirmar tu identidad mediante el reconocimiento facial. Solo toma unos segundos.',
  'The facial recognition confirms that it is you requesting this new appointment, and that you are aware of and agree to attend.':
    'El reconocimiento facial confirma que eres tú quien solicita este nuevo turno, y que estás en conocimiento y de acuerdo en asistir.',
  Continue: 'Continuar',
};
